import {
  makeStyles,
  tokens,
  shorthands,
} from '@fluentui/react-components';

export const useStyles = makeStyles({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.colorNeutralBackground3,
    ...shorthands.borderLeft('1px', 'solid', tokens.colorNeutralStroke2),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...shorthands.padding(tokens.spacingVerticalXXL, tokens.spacingHorizontalXXL, tokens.spacingVerticalM, tokens.spacingHorizontalL),
  },
  title: {
    fontSize: tokens.fontSizeBase500,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase500,
    color: tokens.colorNeutralForeground1,
    opacity: 1,
    ...shorthands.padding('0px', tokens.spacingHorizontalS),
    ...shorthands.margin('0px'),
    ...shorthands.transition([
      ['width', tokens.durationFast, '0', tokens.curveAccelerateMid],
      ['height', tokens.durationFast, '0', tokens.curveAccelerateMid],
      ['padding', tokens.durationFast, '0', tokens.curveAccelerateMid],
      ['opacity', tokens.durationFast, '0', tokens.curveAccelerateMid],
      ['visibility', tokens.durationFast, 'hidden', tokens.curveAccelerateMid],
    ]),
  },
  collapsedTitle: {
    ...shorthands.padding('0px'),
    opacity: 0,
    width: '0px',
    height: '0px',
    visibility: 'hidden',
  },
  collapseButton: {
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground3Hover,
    },
  },
  content: {
    opacity: 1,
    ...shorthands.overflow('auto'),
    ...shorthands.flex(1),
    ...shorthands.padding('0px', tokens.spacingHorizontalXXL, tokens.spacingVerticalXXL),
    ...shorthands.transition([
      ['width', tokens.durationFast, '0', tokens.curveAccelerateMid],
      ['height', tokens.durationFast, '0', tokens.curveAccelerateMid],
      ['padding', tokens.durationFast, '0', tokens.curveAccelerateMid],
      ['opacity', tokens.durationFast, '0', tokens.curveAccelerateMid],
      ['visibility', tokens.durationFast, 'hidden', tokens.curveAccelerateMid],
    ]),
  },
  collapsedContent: {
    ...shorthands.padding('0px'),
    opacity: 0,
    width: '0px',
    height: '0px',
    visibility: 'hidden',
  },
});
